// extracted by mini-css-extract-plugin
module.exports = {"customerAdmins":"customerAdmins__bLdRk","header":"header__Y62m1","email":"email__2T1d0","admin":"admin__JYOtC"};